import { CoordinationCardVersion } from 'data/models/CoordinationCardVersion';

export interface CancelledCoordinationCardDetailsSettingsTabParams {
    CoordinationCard : CoordinationCardVersion;
}

export type CancelledCoordinationCardDetailsSettingsTab = ReturnType<typeof CancelledCoordinationCardDetailsSettingsTab>;
export function CancelledCoordinationCardDetailsSettingsTab(
    { CoordinationCard } : CancelledCoordinationCardDetailsSettingsTabParams
) {
    return { CoordinationCard };
}



// WEBPACK FOOTER //
// ./apps/portcall/coordinationcarddetails/cancelledsettings.ts